module.exports = __webpack_public_path__ + "img/contact.5323ac64.svg";